import React, { useState } from 'react';
import styles from './LectureModal.module.scss';

const LectureModal = ({ onClose }) => {
  const weeks = [2, 3, 4, 5, 6, 7];
  const [showCodeModal, setShowCodeModal] = useState(false);
  const [showWeek3Modal, setShowWeek3Modal] = useState(false);
  const [showWeek4Modal, setShowWeek4Modal] = useState(false);
  const [showWeek5Modal, setShowWeek5Modal] = useState(false);
  const [showWeek6Modal, setShowWeek6Modal] = useState(false);
  const [showWeek7Modal, setShowWeek7Modal] = useState(false);
  
  const handleWeekClick = (week) => {
    if (week === 2) {
      setShowCodeModal(true);
    } else if (week === 3) {
      setShowWeek3Modal(true);
    } else if (week === 4) {
      setShowWeek4Modal(true);
    } else if (week === 5) {
      setShowWeek5Modal(true);
    } else if (week === 6) {
      setShowWeek6Modal(true);
    } else if (week === 7) {
      setShowWeek7Modal(true);
    } else {
      alert(`${week}주차는 해당 주차에 공개됩니다!`);
    }
  };

  const copyCode = (code) => {
    navigator.clipboard.writeText(code);
    alert('코드가 클립보드에 복사되었습니다!');
  };

  const downloadDriver = () => {
    const downloadLink = document.createElement('a');
    downloadLink.href = `${process.env.PUBLIC_URL}/lecture/CH340_driver.zip`;
    downloadLink.download = 'CH340_driver.zip';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const connectionCode = `#include <LedControl.h>

// 핀 연결: DIN=10, CLK=12, CS=11
LedControl lc = LedControl(10, 12, 11, 2); // 마지막 숫자 '2'는 매트릭스 개수

void setup() {
  // 각 매트릭스 초기화
  for (int i = 0; i < 2; i++) {
    lc.shutdown(i, false);    // 절전 모드 해제
    lc.setIntensity(i, 0);    // 밝기 0 (최저 밝기)
    lc.clearDisplay(i);       // 디스플레이 초기화
  }

  // 모든 LED 켜기
  for (int device = 0; device < 2; device++) {
    for (int row = 0; row < 8; row++) {
      for (int col = 0; col < 8; col++) {
        lc.setLed(device, row, col, true);
      }
    }
  }
}

void loop() {
  // loop에서는 아무것도 하지 않음
}`;

  const blinkCode = `#include <LedControl.h>

// 핀 연결: DIN=10, CLK=12, CS=11
LedControl lc = LedControl(10, 12, 11, 2); // 마지막 숫자 '2'는 매트릭스 개수

void setup() {
  for (int i = 0; i < 2; i++) {
    lc.shutdown(i, false);  // 절전 해제
    lc.setIntensity(i, 0);  // 최저 밝기
    lc.clearDisplay(i);     // 초기화
  }
}

void loop() {
  // 패턴 1: 짝수칸만 켜기
  for (int device = 0; device < 2; device++) {
    for (int row = 0; row < 8; row++) {
      for (int col = 0; col < 8; col++) {
        bool isEven = (row + col) % 2 == 0;
        lc.setLed(device, row, col, isEven);
      }
    }
  }
  delay(500); //0.5초 대기

  // 패턴 2: 홀수칸만 켜기 (반대 패턴)
  for (int device = 0; device < 2; device++) {
    for (int row = 0; row < 8; row++) {
      for (int col = 0; col < 8; col++) {
        bool isOdd = (row + col) % 2 == 1;
        lc.setLed(device, row, col, isOdd);
      }
    }
  }
  delay(500); //0.5초 대기
}
`;

  const faceCode = `#include <LedControl.h>

// 핀 연결: DIN=10, CLK=12, CS=11
LedControl lc = LedControl(10, 12, 11, 2);

// 도트매트릭스 표정들
// 표정 저장용 변수 생성 [표정 개수][행 개수][열 개수]
const byte faces[3][8][16] = {
  // 😀 사랑스러움
  {
    {0,1,1,0,1,1,0,0,   0,0,1,1,0,1,1,0},
    {1,1,1,1,1,1,1,0,   0,1,1,1,1,1,1,1},
    {1,1,1,1,1,1,1,0,   0,1,1,1,1,1,1,1},
    {0,1,1,1,1,1,0,0,   0,0,1,1,1,1,1,0},
    {0,0,1,1,1,0,0,0,   0,0,0,1,1,1,0,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,0,0,0,0,1,0,   0,1,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,0}
  },

  // 😢 슬픔
  {
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,1,1,1,1,1,0,0,   0,0,1,1,1,1,1,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,0,1,0,0,0,1,   1,0,0,0,1,0,0,0},
    {0,0,0,1,0,0,1,0,   0,1,0,0,1,0,0,0},
    {0,0,0,1,0,0,1,0,   0,1,0,0,1,0,0,0},
    {0,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,0}
  },

  // 😐 기쁨
  {
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,1,0,1,0,0,0,   0,0,0,1,0,1,0,0},
    {0,1,0,0,0,1,0,0,   0,0,1,0,0,0,1,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,1,1,1,   1,1,1,0,0,0,0,0},
    {0,0,0,0,0,1,0,0,   0,0,1,0,0,0,0,0},
    {0,0,0,0,0,0,1,1,   1,1,0,0,0,0,0,0}
  },
};

// 표정 데이터의 개수를 적습니다.
const int numberOfFaces = 3;

// 현재 보여줄 표정 번호
int currentFaceIndex = 0;

void setup() {
  // LED 매트릭스 2개(왼쪽, 오른쪽)를 초기화합니다
  for (int device = 0; device < 2; device++) {
    lc.shutdown(device, false);     // 절전 모드 해제
    lc.setIntensity(device, 1);     // 밝기 설정 (0~15)
    lc.clearDisplay(device);        // 화면 초기화
  }
}

void loop() {
  // 현재 표정을 LED 매트릭스에 표시
  showFace(currentFaceIndex);

  // 2초(2000ms) 동안 기다립니다
  delay(2000);

  // 다음 표정으로 넘어갑니다 (순환)
  currentFaceIndex = currentFaceIndex + 1;
  if (currentFaceIndex >= numberOfFaces) {
    currentFaceIndex = 0;
  }
}

void showFace(int index) {
  // 각 행(row)에 대해 반복
  for (int row = 0; row < 8; row++) {

    // 왼쪽 매트릭스 (0번 디바이스): 열 0~7
    for (int col = 0; col < 8; col++) {
      bool isOn = (faces[index][row][col] == 1);
      lc.setLed(0, row, col, isOn);  // 왼쪽 매트릭스
    }

    // 오른쪽 매트릭스 (1번 디바이스): 열 0~7로 맞춰야 하므로 col은 0~7이지만 실제 인덱스는 8~15
    for (int col = 0; col < 8; col++) {
      bool isOn = (faces[index][row][col + 8] == 1);
      lc.setLed(1, row, col, isOn);  // 오른쪽 매트릭스
    }
  }
}`;

  const buttonFaceCode = `#include <LedControl.h>  // LED 매트릭스 제어 라이브러리

// 핀 연결 설정: DIN=10, CLK=12, CS=11, 장치 수=2
LedControl lc = LedControl(10, 12, 11, 2);

// 버튼이 연결된 핀 번호
const int buttonPin = 7;

// 마지막으로 버튼을 누른 시간을 저장
unsigned long lastButtonPress = 0;

// 디바운스를 위한 시간 설정 (ms)
// (디바운스란 버튼을 누를 때 발생하는 빠른 ON/OFF 신호 떨림을 무시하는 기술)
const unsigned long debounceDelay = 200;

// 도트 매트릭스에 표시할 얼굴 패턴 데이터
// 3가지 표정이 각각 8행 16열로 저장되어 있음
const byte faces[3][8][16] = {
  // 😀 사랑스러움
  {
    {0,1,1,0,1,1,0,0,   0,0,1,1,0,1,1,0},
    {1,1,1,1,1,1,1,0,   0,1,1,1,1,1,1,1},
    {1,1,1,1,1,1,1,0,   0,1,1,1,1,1,1,1},
    {0,1,1,1,1,1,0,0,   0,0,1,1,1,1,1,0},
    {0,0,1,1,1,0,0,0,   0,0,0,1,1,1,0,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,0,0,0,0,1,0,   0,1,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,0}
  },
  // 😢 슬픔
  {
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,1,1,1,1,1,0,0,   0,0,1,1,1,1,1,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,0,1,0,0,0,1,   1,0,0,0,1,0,0,0},
    {0,0,0,1,0,0,1,0,   0,1,0,0,1,0,0,0},
    {0,0,0,1,0,0,1,0,   0,1,0,0,1,0,0,0},
    {0,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,0}
  },
  // 😐 기쁨
  {
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,1,0,1,0,0,0,   0,0,0,1,0,1,0,0},
    {0,1,0,0,0,1,0,0,   0,0,1,0,0,0,1,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,1,1,1,   1,1,1,0,0,0,0,0},
    {0,0,0,0,0,1,0,0,   0,0,1,0,0,0,0,0},
    {0,0,0,0,0,0,1,1,   1,1,0,0,0,0,0,0}
  },
};

// 표정의 총 개수
const int numberOfFaces = 3;
// 현재 표시 중인 표정 인덱스
int currentFaceIndex = 0;

void setup() {
  // 버튼 핀을 입력 모드로 설정하면서 풀업(PULLUP) 저항 사용
  pinMode(buttonPin, INPUT_PULLUP);

  /* 
  ➡️ INPUT_PULLUP이란?
  - 풀업(PULLUP)은 핀을 기본적으로 HIGH(1, 5V) 상태로 유지하게 하는 기능입니다.
  - 버튼을 누르지 않았을 때 핀 값이 HIGH(1)가 되고,
  - 버튼을 누르면 GND(0V)에 연결되어 LOW(0)이 됩니다.
  - 이 방식을 사용하면, 버튼 노이즈를 줄이는 데 도움이 됩니다.
  */

  // 두 개의 도트 매트릭스 장치 초기화
  for (int device = 0; device < 2; device++) {
    lc.shutdown(device, false);    // 절전모드 해제
    lc.setIntensity(device, 1);    // 밝기 설정 (0~15)
    lc.clearDisplay(device);       // 디스플레이 초기화(모든 LED 끔)
  }

  // 프로그램 시작 시 첫 표정 표시
  showFace(currentFaceIndex);
}

void loop() {
  // 버튼이 눌렸는지 확인 (LOW가 눌린 상태)
  if (digitalRead(buttonPin) == LOW) {
    // 마지막 눌림 이후 debounceDelay(ms) 이상 경과했는지 확인
    if (millis() - lastButtonPress > debounceDelay) {
      currentFaceIndex++;  // 다음 표정으로 이동
      if (currentFaceIndex >= numberOfFaces) {
        currentFaceIndex = 0;  // 표정 인덱스가 범위를 넘어가면 0으로 초기화
      }
      showFace(currentFaceIndex); // 새로운 표정 표시
      lastButtonPress = millis(); // 마지막 버튼 눌림 시간 업데이트
    }
  }
}

// 선택한 표정을 도트 매트릭스에 표시하는 함수
void showFace(int index) {
  for (int row = 0; row < 8; row++) {         // 8줄 반복
    for (int col = 0; col < 8; col++) {        // 왼쪽 매트릭스 (device 0) 제어
      bool isOn = (faces[index][row][col] == 1);  
      lc.setLed(0, row, col, isOn);
    }
    for (int col = 0; col < 8; col++) {        // 오른쪽 매트릭스 (device 1) 제어
      bool isOn = (faces[index][row][col + 8] == 1);
      lc.setLed(1, row, col, isOn);
    }
  }
}`;

  const week6Code = `#include <LedControl.h>

// 핀 연결: DIN=10, CLK=12, CS=11
LedControl lc = LedControl(10, 12, 11, 2);

//표정이 바뀌는 시간 설정 1초는 1000 2초는 2000
int dealyTime = 2000;

// 도트매트릭스 표정들
// 표정 저장용 변수 생성 [표정 개수][행 개수][열 개수]
const byte faces[][8][16] = {
  // 😀 사랑스러움
  {
    {0,1,1,0,1,1,0,0,   0,0,1,1,0,1,1,0},
    {1,1,1,1,1,1,1,0,   0,1,1,1,1,1,1,1},
    {1,1,1,1,1,1,1,0,   0,1,1,1,1,1,1,1},
    {0,1,1,1,1,1,0,0,   0,0,1,1,1,1,1,0},
    {0,0,1,1,1,0,0,0,   0,0,0,1,1,1,0,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,0,0,0,0,1,0,   0,1,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,0}
  },

  // 😢 슬픔
  {
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,1,1,1,1,1,0,0,   0,0,1,1,1,1,1,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,0,1,0,0,0,1,   1,0,0,0,1,0,0,0},
    {0,0,0,1,0,0,1,0,   0,1,0,0,1,0,0,0},
    {0,0,0,1,0,0,1,0,   0,1,0,0,1,0,0,0},
    {0,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,0}
  },

  // 😐 기쁨
  {
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,1,0,1,0,0,0,   0,0,0,1,0,1,0,0},
    {0,1,0,0,0,1,0,0,   0,0,1,0,0,0,1,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,1,1,1,   1,1,1,0,0,0,0,0},
    {0,0,0,0,0,1,0,0,   0,0,1,0,0,0,0,0},
    {0,0,0,0,0,0,1,1,   1,1,0,0,0,0,0,0}
  },
};

// 표정 데이터의 개수를 자동으로 계산해줍니다.
const int numberOfFaces = sizeof(faces) / sizeof(faces[0]);

// 현재 보여줄 표정 번호
int currentFaceIndex = 0;

void setup() {
  // LED 매트릭스 2개(왼쪽, 오른쪽)를 초기화합니다
  for (int device = 0; device < 2; device++) {
    lc.shutdown(device, false);     // 절전 모드 해제
    lc.setIntensity(device, 1);     // 밝기 설정 (0~15)
    lc.clearDisplay(device);        // 화면 초기화
  }
}

void loop() {
  // 현재 표정을 LED 매트릭스에 표시
  showFace(currentFaceIndex);

  // delayTime 동안 기다립니다.
  delay(dealyTime);

  // 다음 표정으로 넘어갑니다 (순환)
  currentFaceIndex = currentFaceIndex + 1;
  if (currentFaceIndex >= numberOfFaces) {
    currentFaceIndex = 0;
  }
}

void showFace(int index) {
  // 각 행(row)에 대해 반복
  for (int row = 0; row < 8; row++) {

    // 왼쪽 매트릭스 (0번 디바이스): 열 0~7
    for (int col = 0; col < 8; col++) {
      bool isOn = (faces[index][row][col] == 1);
      lc.setLed(0, row, col, isOn);  // 왼쪽 매트릭스
    }

    // 오른쪽 매트릭스 (1번 디바이스): 열 0~7로 맞춰야 하므로 col은 0~7이지만 실제 인덱스는 8~15
    for (int col = 0; col < 8; col++) {
      bool isOn = (faces[index][row][col + 8] == 1);
      lc.setLed(1, row, col, isOn);  // 오른쪽 매트릭스
    }
  }
}`;

  const patternCode = `#include <LedControl.h>

// 핀 연결: DIN=10, CLK=12, CS=11
LedControl lc = LedControl(10, 12, 11, 2);

//표정이 바뀌는 시간 설정 1초는 1000 2초는 2000
int dealyTime = 1000;

// 도트매트릭스 표정들
// 패턴 저장용 변수 생성 [표정 개수][행 개수][열 개수]
const byte faces[][8][16] = {
  // 패턴 1: 비어있는 상태 (도입부)
  {
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0}
  },

  // 패턴 2: 가장자리 프레임
  {
    {1,1,1,1,1,1,1,1,   1,1,1,1,1,1,1,1},
    {1,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,1},
    {1,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,1},
    {1,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,1},
    {1,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,1},
    {1,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,1},
    {1,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,1},
    {1,1,1,1,1,1,1,1,   1,1,1,1,1,1,1,1}
  },

  // 패턴 3: 대각선 채우기
  {
    {1,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,1},
    {0,1,0,0,0,0,0,0,   0,0,0,0,0,0,1,0},
    {0,0,1,0,0,0,0,0,   0,0,0,0,0,1,0,0},
    {0,0,0,1,0,0,0,0,   0,0,0,0,1,0,0,0},
    {0,0,0,0,1,0,0,0,   0,0,0,1,0,0,0,0},
    {0,0,0,0,0,1,0,0,   0,0,1,0,0,0,0,0},
    {0,0,0,0,0,0,1,0,   0,1,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,1,   1,0,0,0,0,0,0,0}
  },

  // 패턴 4: 격자판
  {
    {1,0,1,0,1,0,1,0,   1,0,1,0,1,0,1,0},
    {0,1,0,1,0,1,0,1,   0,1,0,1,0,1,0,1},
    {1,0,1,0,1,0,1,0,   1,0,1,0,1,0,1,0},
    {0,1,0,1,0,1,0,1,   0,1,0,1,0,1,0,1},
    {1,0,1,0,1,0,1,0,   1,0,1,0,1,0,1,0},
    {0,1,0,1,0,1,0,1,   0,1,0,1,0,1,0,1},
    {1,0,1,0,1,0,1,0,   1,0,1,0,1,0,1,0},
    {0,1,0,1,0,1,0,1,   0,1,0,1,0,1,0,1}
  },

  // 패턴 5: 중앙 십자
  {
    {0,0,0,0,1,1,0,0,   0,0,1,1,0,0,0,0},
    {0,0,0,0,1,1,0,0,   0,0,1,1,0,0,0,0},
    {0,0,0,0,1,1,0,0,   0,0,1,1,0,0,0,0},
    {1,1,1,1,1,1,1,1,   1,1,1,1,1,1,1,1},
    {1,1,1,1,1,1,1,1,   1,1,1,1,1,1,1,1},
    {0,0,0,0,1,1,0,0,   0,0,1,1,0,0,0,0},
    {0,0,0,0,1,1,0,0,   0,0,1,1,0,0,0,0},
    {0,0,0,0,1,1,0,0,   0,0,1,1,0,0,0,0}
  },

  // 패턴 6: 다시 비움 (클리어)
  {
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0},
    {0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0}
  }
};

// 패턴 데이터의 개수를 자동으로 계산해줍니다.
const int numberOfFaces = sizeof(faces) / sizeof(faces[0]);

// 현재 보여줄 표정 번호
int currentFaceIndex = 0;

void setup() {
  // LED 매트릭스 2개(왼쪽, 오른쪽)를 초기화합니다
  for (int device = 0; device < 2; device++) {
    lc.shutdown(device, false);     // 절전 모드 해제
    lc.setIntensity(device, 1);     // 밝기 설정 (0~15)
    lc.clearDisplay(device);        // 화면 초기화
  }
}

void loop() {
  // 현재 패턴을 LED 매트릭스에 표시
  showFace(currentFaceIndex);

  // delayTime 동안 기다립니다.
  delay(dealyTime);

  // 다음 패턴으로 넘어갑니다 (순환)
  currentFaceIndex = currentFaceIndex + 1;
  if (currentFaceIndex >= numberOfFaces) {
    currentFaceIndex = 0;
  }
}

void showFace(int index) {
  // 각 행(row)에 대해 반복
  for (int row = 0; row < 8; row++) {

    // 왼쪽 매트릭스 (0번 디바이스): 열 0~7
    for (int col = 0; col < 8; col++) {
      bool isOn = (faces[index][row][col] == 1);
      lc.setLed(0, row, col, isOn);  // 왼쪽 매트릭스
      delay(50);
    }

    // 오른쪽 매트릭스 (1번 디바이스): 열 0~7로 맞춰야 하므로 col은 0~7이지만 실제 인덱스는 8~15
    for (int col = 0; col < 8; col++) {
      bool isOn = (faces[index][row][col + 8] == 1);
      lc.setLed(1, row, col, isOn);  // 오른쪽 매트릭스
      delay(50);
    }
  }
}`;


  return (
    <>
      <div className={styles.modalOverlay}>
        <div className={styles.modalContent}>
          <h2>도트매트릭스 강의자료</h2>
          <div className={styles.weekButtons}>
            {weeks.map(week => (
              <button
                key={week}
                className={styles.weekButton}
                onClick={() => handleWeekClick(week)}
              >
                {week}주차
              </button>
            ))}
          </div>
          <button className={styles.closeButton} onClick={onClose}>
            닫기
          </button>
        </div>
      </div>

      {showCodeModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.codeModalContent}>
            <h2>2주차 - 아두이노 연결</h2>
            <div className={styles.codeContainer}>
              <pre className={styles.code}>
{`void setup() {
  // 시리얼 통신을 시작합니다. (9600bps 속도로 설정)
  Serial.begin(9600);

  // 시리얼 모니터에 "연결완료"라는 메시지를 출력합니다.
  Serial.println("연결완료");
}

void loop() {
  // 반복해서 실행되는 부분이지만,
  // 현재는 아무 작업도 하지 않으므로 비워둡니다.
}`}
              </pre>
            </div>
            <div className={styles.buttonContainer}>
              <button className={styles.copyButton} onClick={() => copyCode(`void setup() {
  // 시리얼 통신을 시작합니다. (9600bps 속도로 설정)
  Serial.begin(9600);

  // 시리얼 모니터에 "연결완료"라는 메시지를 출력합니다.
  Serial.println("연결완료");
}

void loop() {
  // 반복해서 실행되는 부분이지만,
  // 현재는 아무 작업도 하지 않으므로 비워둡니다.
}`)}>
                코드 복사하기
              </button>
              <button className={styles.closeButton} onClick={() => setShowCodeModal(false)}>
                닫기
              </button>
            </div>
          </div>
        </div>
      )}

      {showWeek3Modal && (
        <div className={styles.modalOverlay}>
          <div className={styles.codeModalContent}>
            <h2>3주차 - 도트매트릭스 실습</h2>
            <div className={styles.week3Content}>
              <div className={styles.section}>
                <h3>1. CH340 드라이버 다운로드</h3>
                <button className={styles.downloadButton} onClick={downloadDriver}>
                  드라이버 다운로드
                </button>
              </div>
              
              <div className={styles.section}>
                <h3>2. 도트매트릭스 최저 밝기기 코드</h3>
                <div className={styles.codeContainer}>
                  <pre className={styles.code}>{connectionCode}</pre>
                </div>
                <button className={styles.copyButton} onClick={() => copyCode(connectionCode)}>
                  코드 복사하기
                </button>
              </div>

              <div className={styles.section}>
                <h3>3. 도트매트릭스 체크판으로 깜빡이는 코드</h3>
                <div className={styles.codeContainer}>
                  <pre className={styles.code}>{blinkCode}</pre>
                </div>
                <button className={styles.copyButton} onClick={() => copyCode(blinkCode)}>
                  코드 복사하기
                </button>
              </div>
            </div>
            <button className={styles.closeButton} onClick={() => setShowWeek3Modal(false)}>
              닫기
            </button>
          </div>
        </div>
      )}

      {showWeek4Modal && (
        <div className={styles.modalOverlay}>
          <div className={styles.codeModalContent}>
            <h2>4주차 - 도트매트릭스 표정 만들기</h2>
            <div className={styles.codeContainer}>
              <pre className={styles.code}>{faceCode}</pre>
            </div>
            <div className={styles.buttonContainer}>
              <button className={styles.copyButton} onClick={() => copyCode(faceCode)}>
                코드 복사하기
              </button>
              <button className={styles.closeButton} onClick={() => setShowWeek4Modal(false)}>
                닫기
              </button>
            </div>
          </div>
        </div>
      )}

      {showWeek5Modal && (
        <div className={styles.modalOverlay}>
          <div className={styles.codeModalContent}>
            <h2>5주차 - 버튼으로 표정 바꾸기</h2>
            <div className={styles.codeContainer}>
              <pre className={styles.code}>{buttonFaceCode}</pre>
            </div>
            <div className={styles.buttonContainer}>
              <button className={styles.copyButton} onClick={() => copyCode(buttonFaceCode)}>
                코드 복사하기
              </button>
              <button className={styles.closeButton} onClick={() => setShowWeek5Modal(false)}>
                닫기
              </button>
            </div>
          </div>
        </div>
      )}

      {showWeek6Modal && (
        <div className={styles.modalOverlay}>
          <div className={styles.codeModalContent}>
            <h2>6주차 - 전시용 도트매트릭스 코드</h2>
            <div className={styles.section}>
              <h3>1. 표정 전시용 코드</h3>
              <div className={styles.codeContainer}>
                <pre className={styles.code}>{week6Code}</pre>
              </div>
              <button className={styles.copyButton} onClick={() => copyCode(week6Code)}>
                코드 복사하기
              </button>
            </div>
            <div className={styles.section}>
              <h3>2. 패턴 전시용 코드</h3>
              <div className={styles.codeContainer}>
                <pre className={styles.code}>{patternCode}</pre>
              </div>
              <button className={styles.copyButton} onClick={() => copyCode(patternCode)}>
                코드 복사하기
              </button>
            </div>
            <button className={styles.closeButton} onClick={() => setShowWeek6Modal(false)}>
              닫기
            </button>
          </div>
        </div>
      )}

      {showWeek7Modal && (
        <div className={styles.modalOverlay}>
          <div className={styles.codeModalContent}>
            <h2>7주차 - 회고 인터뷰</h2>
            <div className={styles.section}>
              <h3>1. ChatGPT 회고 링크</h3>
              <div className={styles.codeContainer}>
                <a 
                  href="https://chatgpt.com/g/g-6824466d5dc4819196575e9dc142a0a8-sancaeghaggyo-saengseonghyeong-ai-jjigmeog-keulraeseu-hoego" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  https://chatgpt.com/g/g-6824466d5dc4819196575e9dc142a0a8-sancaeghaggyo-saengseonghyeong-ai-jjigmeog-keulraeseu-hoego
                </a>
              </div>
              <button className={styles.copyButton} onClick={() => copyCode('https://chatgpt.com/g/g-6824466d5dc4819196575e9dc142a0a8-sancaeghaggyo-saengseonghyeong-ai-jjigmeog-keulraeseu-hoego')}>
                링크 복사하기
              </button>
            </div>
            <div className={styles.section}>
              <h3>2. 회고 인터뷰 프롬프트</h3>
              <div className={styles.codeContainer}>
                <pre className={styles.code}>{`너는 지금 아두이노와 AI 수업을 마친 참가자에게 회고 인터뷰를 진행하는 회고 코치야.  
인터뷰는 아래 질문 4개를 차례대로, 한 번에 하나씩 진행해.  
각 질문은 부드럽고 짧게 말하고, 참가자의 응답이 들어오면 꼭 따뜻하게 공감하고, 다음 질문으로 자연스럽게 넘어가.  
 
**질문 리스트:**  
1. 이 수업에서 가장 기억에 남는 장면은 어떤 것이었나요?  
2. 그 장면에서 어떤 감정을 느꼈나요?  
3. 어떤 기술이 특히 재미있거나 어렵게 느껴졌나요?  
4. 이 기술을 앞으로 어디에 써보고 싶나요?
 
모든 응답이 끝나면, 다음 형식으로 참가자의 응답을 정리해서 **회고 시각화 카드**로 만들어줘:
 
---
[ 코드명: 직접 만든 임의의 코드명 (예: SUN-A01) ]
 
"응답자의 마지막 답변을 압축한 키워드 (예: 도전!)"
 
기억에 남는 순간:  
{1번 질문의 응답}
 
감정:  
{2번 질문의 응답}
 
기술 탐색:  
{3번 질문의 응답}
 
상상한 확장:  
{4번 질문의 응답}
 
✨ 이 수업은 나에게 {1~4번 내용을 압축한 한 문장 형태로 마무리}
---
 
위와 같은 결과물을 한글로 출력해줘.  
시각적으로 보기 좋도록 **줄 간격을 명확히** 띄우고, **불필요한 설명은 생략**해.`}</pre>
              </div>
              <button className={styles.copyButton} onClick={() => copyCode(`너는 지금 아두이노와 AI 수업을 마친 참가자에게 회고 인터뷰를 진행하는 회고 코치야.  
인터뷰는 아래 질문 4개를 차례대로, 한 번에 하나씩 진행해.  
각 질문은 부드럽고 짧게 말하고, 참가자의 응답이 들어오면 꼭 따뜻하게 공감하고, 다음 질문으로 자연스럽게 넘어가.  
 
**질문 리스트:**  
1. 이 수업에서 가장 기억에 남는 장면은 어떤 것이었나요?  
2. 그 장면에서 어떤 감정을 느꼈나요?  
3. 어떤 기술이 특히 재미있거나 어렵게 느껴졌나요?  
4. 이 기술을 앞으로 어디에 써보고 싶나요?
 
모든 응답이 끝나면, 다음 형식으로 참가자의 응답을 정리해서 **회고 시각화 카드**로 만들어줘:
 
---
[ 코드명: 직접 만든 임의의 코드명 (예: SUN-A01) ]
 
"응답자의 마지막 답변을 압축한 키워드 (예: 도전!)"
 
기억에 남는 순간:  
{1번 질문의 응답}
 
감정:  
{2번 질문의 응답}
 
기술 탐색:  
{3번 질문의 응답}
 
상상한 확장:  
{4번 질문의 응답}
 
✨ 이 수업은 나에게 {1~4번 내용을 압축한 한 문장 형태로 마무리}
---
 
위와 같은 결과물을 한글로 출력해줘.  
시각적으로 보기 좋도록 **줄 간격을 명확히** 띄우고, **불필요한 설명은 생략**해.`)}>
                코드 복사하기
              </button>
            </div>
            <button className={styles.closeButton} onClick={() => setShowWeek7Modal(false)}>
              닫기
            </button>
          </div>
        </div>
      )}

    </>
  );
};

export default LectureModal; 